import { parsePhoneNumber } from 'libphonenumber-js/max';
import { Country } from '../../../utils/countryData';
import { isEmpty, ValidationResult } from '../../../utils/getValidator';

export const getPhoneNumber = (value: string, defaultCountry?: Country) => {
  try {
    return parsePhoneNumber(value, defaultCountry);
  } catch (e) {
    return undefined;
  }
};

export type PhoneNumberValidation = { required?: boolean; restrictCountry?: boolean; mobileOnly?: boolean };

const getPhoneNumberValidator =
  ({ required, restrictCountry, mobileOnly, country }: PhoneNumberValidation & { country: Country }) =>
  (value: string): ValidationResult => {
    if (!required && isEmpty(value)) {
      return undefined;
    } else if (isEmpty(value)) {
      return { key: 'required' };
    }

    const phoneNumber = getPhoneNumber(value, country);
    if (!phoneNumber?.isValid()) {
      return { key: 'invalid' };
    } else if (restrictCountry && phoneNumber.country !== country) {
      return { key: 'phoneNumber.noForeign' };
    } else if (mobileOnly && phoneNumber.getType() !== 'MOBILE') {
      return { key: 'phoneNumber.mobileOnly' };
    } else {
      return undefined;
    }
  };

export default getPhoneNumberValidator;
